import { FC, ReactNode } from 'react'
import { match } from 'ts-pattern'

import {
  BorderRadius6,
  GreenGreen10,
  GreenGreen80,
  GreyGrey20,
  GreyGrey70,
  IndigoIndigo10,
  IndigoIndigo60,
  OrangeOrange10,
  OrangeOrange80,
  PurplePurple10,
  PurplePurple80,
  RedRed10,
  RedRed80,
  TurquoiseTurquoise10,
  TurquoiseTurquoise80,
  YellowYellow10,
  YellowYellow80,
  Center,
  Box
} from '@sequencehq/core-components'

export type IconTheme =
  | 'grey'
  | 'indigo'
  | 'yellow'
  | 'green'
  | 'orange'
  | 'purple'
  | 'red'
  | 'turquoise'

type Props = {
  theme: IconTheme
  icon: ReactNode
  boxSize: string
}

export const NodeIconTemplate: FC<Props> = ({ theme, icon, boxSize }) => {
  const { color, backgroundColor } = match(theme)
    .with('grey', () => ({ color: GreyGrey70, backgroundColor: GreyGrey20 }))
    .with('indigo', () => ({
      color: IndigoIndigo60,
      backgroundColor: IndigoIndigo10
    }))
    .with('yellow', () => ({
      color: YellowYellow80,
      backgroundColor: YellowYellow10
    }))
    .with('green', () => ({
      color: GreenGreen80,
      backgroundColor: GreenGreen10
    }))
    .with('orange', () => ({
      color: OrangeOrange80,
      backgroundColor: OrangeOrange10
    }))
    .with('purple', () => ({
      color: PurplePurple80,
      backgroundColor: PurplePurple10
    }))
    .with('red', () => ({
      color: RedRed80,
      backgroundColor: RedRed10
    }))
    .with('turquoise', () => ({
      color: TurquoiseTurquoise80,
      backgroundColor: TurquoiseTurquoise10
    }))
    .exhaustive()

  return (
    <Center
      boxSize={boxSize}
      backgroundColor={backgroundColor}
      borderRadius={BorderRadius6}
      flexShrink="0"
    >
      <Box color={color} boxSize="16px">
        {icon}
      </Box>
    </Center>
  )
}
